import React from 'react';
import createHistory from '@guestyci/history/createHistory';
import LocalizationProvider from '@guestyci/localize/LocalizationProvider';
import { FeatureToggleProvider } from '@guestyci/feature-toggle-fe';
import { Router } from 'react-router-dom';
import '@guestyci/arc-styles';
import { Toaster } from '@guestyci/arc';

import { utils } from 'utils';
import { getEnv } from 'utils/env';
import AppRoutes from './AppRoutes';
import {
  getLanguageByUrlLocale,
  setLanguage,
} from './new-auth/utils/localeHelper';

utils.eventsLogger.initLoggers();

const urlLocale = new URLSearchParams(window.location.search).get('locale');
if (urlLocale) {
  const lang = getLanguageByUrlLocale(urlLocale);
  setLanguage(lang);
  // 'initial_language' is read by onboarding-page to check whether the user changed
  // the language during the session before updating their language preference.
  // https://github.com/guestyorg/onboarding-page/blob/e242e1ba8bb8c986ed0eb4c8ee3052cda276e466/src/helpers/onboarding.helper.ts#L35
  window.localStorage.setItem('initial_language', lang);
}

const { env } = getEnv();
const history = createHistory({ baseUrl: '/auth', isFragment: false });

const AppProvider = () => {
  return (
    <Router history={history}>
      <LocalizationProvider>
        <FeatureToggleProvider env={env} accountId="anonymus">
          <AppRoutes />
          <Toaster />
        </FeatureToggleProvider>
      </LocalizationProvider>
    </Router>
  );
};

export { AppProvider };
